import { ListViewOrderBy } from './types'

export const getOrderByQueryValue = (orderBy: ListViewOrderBy) => {
    if (!orderBy?.id) return undefined
    return `${orderBy.desc ? '-' : ''}${orderBy.id}`
}
